import Entity from '../Entity';

export default class ContactCategory implements Entity {
  constructor(public id: number, public name: string, public note: string) {}
}
